{
  "10ffbe511de09f84": "Former invoice",
  "24cb98ea86f38d17": "View invoice",
  "2bc748490ad9ba4e": "{{invoiceCount}} invoice",
  "359337f0a9c68324": "(revised)",
  "37945f0742ea2cc4": "Dispute invoice",
  "3a8931a9b2f6bf69": "Dispute",
  "42e9524eb188efbd": "View former invoice",
  "472c6c914210d3d9": "View timesheet",
  "4a90e7d8d982f4c2": "View dispute for invoice #{{invoiceNumber}}",
  "4b80e74f3fa47867": "Unpaid",
  "5b1a1186e5e400a9": "View invoice dispute",
  "5d906349d4fb9e4b": "Dispute: {{status}}",
  "6171b2a461207d19": "Statement",
  "6471421a56ffde3c": "Billing portal",
  "6d320a315fe443f9": "Timesheet",
  "723afa394daeea97": "Pay",
  "75b6330de57a7203": "Due {{dueDate}}",
  "79c2657890c42470": "View dispute",
  "8f74e5015dd26f64": "Invoice History",
  "91e33e3ba5c1ca1a": "Previous year",
  "920e413c7d411b61": "Status",
  "955b9e7a497b0ac3": "Account statement",
  "9ecae17e665870ab": "Invoice #{{invoiceNumber}}",
  "a21a5dc62ee1cde3": "Next year",
  "a328add3ebaecf9b": "{{invoiceCount}} invoices",
  "b1dead56e7d7adf2": "Pay invoice",
  "b4e929d8bcfe0418": "Documents",
  "b832002da297545f": "Invoice",
  "be76c803bf1ebe28": "Revised invoices",
  "c9b3c38247f744e1": "Total",
  "d660945bc2991320": "Overdue",
  "dcc839a4015c4b7d": "View",
  "e1cb6d30fa3f17ee": "Due date",
  "e1dd7ffca8e92b69": "View invoice #{{invoiceNumber}}",
  "e5030091dc4e3004": "View dispute for former invoice",
  "e6b30f9398c0725b": "No invoices",
  "fa094114509b07b6": "Failed to open the billing portal. Please try again.",
  "fb81b961af456e5e": "Paid",
  "fc799c7371bffd02": "Invoice details"
}
